export class UserActionRequired {
  actionRequired;
  actionType;
  static type = '[ActionRequiredState] User action required';
  constructor(actionRequired, actionType) {
    this.actionRequired = actionRequired;
    this.actionType = actionType;
  }
}
export class UserActionDone {
  static type = '[ActionRequiredState] User action done';
}
